import React from 'react';
import { useContext } from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import Icon from 'react-native-easy-icon';
import { LinearGradientCard } from '../linear-gradient-card/linear-gradient-card';
import { ThemeContext } from '../contexts/ThemeContext';

export enum ToastType {
  WARNING = 'WARNING',
  DANGER = 'DANGER',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
export interface ToastProps {
  open: boolean;
  setToast: (value: boolean) => void;
  onButtonClick?: () => void;
  title: string;
  description: string;
  showButton?: boolean;
  buttonText?: string;
  toastType?: ToastType;
  extraComponents?: any;
}

export const Toast = ({
  open,
  setToast,
  onButtonClick,
  title,
  description,
  showButton,
  buttonText,
  toastType,
  extraComponents,
}: ToastProps) => {
  const currentTheme = useContext(ThemeContext);
  const { theme } = currentTheme;
  if (!open) {
    return null;
  }
  const renderColor = (toastType: ToastType) => {
    switch (toastType) {
      case ToastType.WARNING:
      case ToastType.DANGER:
      case ToastType.SUCCESS:
        return '#6BBE4D';
      case ToastType.ERROR:
        return '#FF0000';
      default:
        return '#6BBE4D';
    }
  };
  return (
    <LinearGradientCard
      cardStyle={[
        styles.toastCard,
        //@ts-ignore
        {
          position: 'fixed',
          borderLeftColor: renderColor(toastType ?? ToastType.SUCCESS),
        },
      ]}
    >
      <View style={styles.toastRoot}>
        <Text
          style={{
            ...theme.fontConfig.bold,
            color: renderColor(toastType ?? ToastType.SUCCESS),
            fontSize: 16,
            marginBottom: 10,
          }}
        >
          {title}
        </Text>
        <Icon
          type="evilicon"
          name="close"
          size={20}
          color="#4a4c57"
          onPress={() => setToast(false)}
        />
      </View>
      <div
        style={{
          ...theme.fontConfig.regular,
          color: '#808285',
          fontSize: 15,
          marginBottom: 20,
        }}
      >
        {description}
      </div>
      {extraComponents}
      {showButton ? (
        <View
          style={{
            alignItems: 'flex-end',
          }}
        >
          <TouchableOpacity
            onPress={onButtonClick}
            style={[
              {
                paddingHorizontal: 10,
                paddingVertical: 8,
                backgroundColor: '#6BBE4D',
                borderRadius: 6,
                width: 100,
              },
            ]}
          >
            <Text
              style={[
                theme.fontConfig.semiBold,
                {
                  fontSize: 14,
                  color: 'white',
                },
              ]}
            >
              {buttonText}
            </Text>
          </TouchableOpacity>
        </View>
      ) : null}
    </LinearGradientCard>
  );
};

const styles = StyleSheet.create({
  toastCard: {
    position: 'absolute',
    top: 10,
    right: 10,
    paddingHorizontal: 25,
    paddingVertical: 15,
    paddingBottom: 20,
    borderLeftWidth: 5,
    borderRadius: 6,
    zIndex: 4200000,
    shadowColor: 'black',
    shadowOpacity: 0.08,
    shadowRadius: 12,
    shadowOffset: { height: 10, width: -5 },
    width: 500,
  },
  toastRoot: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    textAlign: 'left',
  },
});
